// FilterComponent.js
import React from 'react';
import CustomAmountFilter from './CustomAmountFilter';
import CustomTextFilter from './CustomTextFilter'
import CustomSelectFilter from './CustomSelectFilter'
import CustomDateFilter from './CustomDateFilter'

const FilterComponent = ({ columns, data, filters: { filters, setFilters, setFilter } }) => {

// Function to compute options for select filters
const computeSelectOptions = accessor => {
  const uniqueValues = new Set(data.map(row => row[accessor]));
  return Array.from(uniqueValues).map(value => ({ value, label: value === "Action"?"Pending":value}));
};

const getOptionsForAccessor = accessor => {
  // Placeholder. Replace this with your actual logic for fetching options.
  if (accessor === 'v_customer') {
    return [
      { value: "1", label: 'VIP Customer' },
      { value: "2", label: 'Executive' },
      { value: "3", label: 'Active Customer' },
      { value: "5", label: 'Pending' },
      { value: "7", label: 'Semi Approve' },
      { value: "8", label: 'Transition' },
      { value: "9", label: 'No Business' },
      { value: "10", label: 'Retention' },
      { value: "11", label: 'Churned' },
      { value: "12", label: 'Shipment' },
    ];
  }

  if (accessor === 'shipping_status') {
    return [
      { value: "0", label: 'Shipping' },
      { value: "1", label: 'Shipped' }
    ];
  }

  if (accessor === 'o_supplier_status') {
    return [
      { value: 1, label: 'Pending' },
      { value: 2, label: 'Rejected' },
      { value: 3, label: 'Approved' },
    ];
  }

  if (accessor === 'ActionsOrderList') {
    return [
      { value: 1, label: 'Pending' },
      { value: 2, label: 'Rejected' },
      { value: 3, label: 'Approved' },
    ];
  }

  if (accessor === 'can_hold') {
    return [
      { value: 1, label: 'ON' },
      { value: 2, label: 'OFF' },
    ];
  }

  if (accessor === 'stock_access_status') {
    return [
      { value: 1, label: 'Access to all' },
      { value: 2, label: 'Access To Selected' },
      { value: 3, label: 'Turn off Access' },
    ];
  }

  if (accessor === 'ActionsOrderList') {
    return [
      { value: 1, label: 'Pending' },
      { value: 2, label: 'Rejected' },
      { value: 3, label: 'Approved' },
      { value: 'Hold - 12 Hours', label: 'Hold - 12 Hours' },
      { value: 'Hold - 24 Hours', label: 'Hold - 24 Hours' },
      { value: 'Hold - 48 Hours', label: 'Hold - 48 Hours' },
    ];
  }

  // if (accessor === 'orderStatus') {
  //   return [
  //     { value: "Action", label: 'Pending' },
  //     { value: "Declined", label: 'Cancelled' },
  //     { value: "Approved", label: 'Approved' }
  //   ];
  // }
  return computeSelectOptions(accessor);
};
  return (
    <div className="filters-container row">
      {columns.map(column => (
        column.filterType === 'text' || column.filterType === 'select' || column.filterType === 'date' || column.filterType === 'amountPrice' ? 
          <div key={column.accessor} className="filter-group col-md-3 mb-3">
            {column.filterType === 'text' && (
              <>
                <label>{column.Header}</label>
                <CustomTextFilter
                  column={{
                    filterValue: filters.find(f => f.accessor === column.accessor)?.value,
                    setFilter: value => {
                      setFilters(oldFilters => {
                        const newFilters = oldFilters.filter(f => f.accessor !== column.accessor);
                        if (value) {
                          newFilters.push({ accessor: column.accessor, value });
                        }
                        setFilter(column.accessor, value); // Update the table filter directly
                        return newFilters;
                      });
                    },
                  }}
                />
              </>
            )}
            {column.filterType === 'select' && (
              <>
                <label>
                  {column.Header === "Round Size" ? "Size" : 
                  column.Header === "Round Color" ? "Color" : 
                  column.Header === "Round Clarity" ? "Clarity" : column.Header}
                  </label>
                <CustomSelectFilter
                  column={{
                    filterValue: filters.find(f => f.accessor === column.accessor)?.value,
                    setFilter: value => {
                      setFilters(oldFilters => {
                        const newFilters = oldFilters.filter(f => f.accessor !== column.accessor);
                        if (value) {
                          newFilters.push({ accessor: column.accessor, value });
                        }
                        setFilter(column.accessor, value); // Update the table filter directly
                        return newFilters;
                      });
                    },
                  }}
                  options={getOptionsForAccessor(column.accessor)} // Use getOptionsForAccessor
                />
            </>
            )}
            {column.filterType === 'date' && (
            <>
                <label>{column.Header}</label>
                
                <CustomDateFilter
                  column={{
                    filterValue: filters.find(f => f.accessor === column.accessor)?.value,
                    setFilter: value => {
                      setFilters(oldFilters => {
                        const newFilters = oldFilters.filter(f => f.accessor !== column.accessor);
                        if (value) {
                          newFilters.push({ accessor: column.accessor, value });
                        }
                        setFilter(column.accessor, value); // Update the table filter directly
                        return newFilters;
                      });
                    },
                  }}
                />
            </>
            )}
            {column.filterType === 'amountPrice' && (
              <>
              {console.log(column)}
              {console.log("filters",filters)}
                <label>{column.Header}</label>
                <CustomAmountFilter
                  column={{
                    filterValue: filters.find(f => f.accessor === column.accessor)?.value,
                    setFilter: value => {
                      setFilters(oldFilters => {
                        const newFilters = oldFilters.filter(f => f.accessor !== column.accessor);
                        if (value) {
                          newFilters.push({ accessor: column.accessor, value });
                        }
                        setFilter(column.accessor, value); // Update the table filter directly
                        return newFilters;
                      });
                    },
                  }}
                />
              </>
            )}
          </div>
        : null
      ))}
    </div>
  );
};

export default FilterComponent;